import { SkipIcon, NextIcon, PrevIcon } from "images";

export const IconNames = {
  Skip: SkipIcon,
  Next: NextIcon,
  Previous: PrevIcon,
};
